export default __webpack_public_path__ + "static/media/kitchenware_hero.1c00ca77.jpg";